<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click.stop="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.47 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM5 5V19H19V5H5Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6 12C6 8.688 8.688 6 12 6C15.312 6 18 8.688 18 12C18 15.312 15.312 18 12 18C8.688 18 6 15.312 6 12ZM7.19997 12C7.19997 14.646 9.35397 16.8 12 16.8C14.646 16.8 16.8 14.646 16.8 12C16.8 9.35401 14.646 7.20001 12 7.20001C9.35397 7.20001 7.19997 9.35401 7.19997 12Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.0003 9.02661L9.02148 9.90409L11.1638 12.2938L11.1627 12.2947L12.0444 13.3185L12.0659 13.3L12.0699 13.3045L12.294 13.1035L15.1158 10.6736L14.2342 9.6498L12.1601 11.4358L10.0003 9.02661Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>

import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>

